
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result"; //候选人答案内容
import ProgressLine from "@/components/question/ProgressLine.vue";
import ProgressCurve from "@/components/question/ProgressCurve.vue";
@Component({
  components: {
    ProgressLine,
    ProgressCurve
  }
})
export default class Audio extends Vue {
  name = "audioPlay";
  @Prop({ type: Boolean, default: true }) visible!: boolean;
  @Prop({ type: Answer, default: () => new Answer() }) answer!: Answer;
  @Prop({ type: String, default: "" }) audioId!: string;
  @Prop({ type: String, default: "" }) audioRef!: string;
  @Prop({ type: String, default: "" }) audioUrl!: string;
  @Prop({ type: Number, default: 0 }) audioIndex!: number;
  @Prop({ type: String, default: "1" }) progressType!: string;
  videoCurrentTime = "00:00:00";
  videoTotalTime = "00:00:00";
  persentLoad = 0;
  audioElement: any = null;
  isPlay = false;
  noAnswer = "未作答";
  activeIndex = -1;
  presentT = 0;
  totalT = 0;
  _this = this;
  mounted() {
    const videoObj = this.$refs[this.audioRef] as HTMLAudioElement;
    // const videoObj = document.getElementById(this.audioId) as HTMLAudioElement;
    if (videoObj) {
      videoObj.addEventListener("canplay", this.getTotalTime);
    }
  }
  beforeDestory() {
    const videoObj = this.$refs[this.audioRef] as HTMLAudioElement;
    videoObj.removeEventListener("canplay", this.getTotalTime);
  }
  changeCurrentTime(data: any) {
    (this.$refs[this.audioRef] as HTMLAudioElement).currentTime = data; // 点击进度条设置视频当前播放点
  }
  changeCurrentWord(data: any) {
    this.videoCurrentTime = this.formatSeconds(data * 1000); // 当前播放时间显示文字
  }
  async getTotalTime() {
    const videoObj = this.$refs[this.audioRef] as HTMLAudioElement;
    // const videoObj = document.getElementById(this.audioId) as HTMLAudioElement
    const audioDuration = videoObj.duration;
    if (isNaN(audioDuration) || audioDuration === Infinity) {
      videoObj.currentTime = 1e101;
      videoObj.ontimeupdate = () => {
        videoObj.ontimeupdate = () => {
          return;
        };
        // 不重新设置currtTime,会直接触发audio的ended事件，因为之前将currentTime设置成了一个比音频时长还大的值。所以要将currentTime重置为初始状态。
        // 注: 这里有一个问题，直接设置为0 是不起作用的。需要重新设置一下audio.currentTime = 1e101;然后再设置为
        videoObj.currentTime = 1e101;
        videoObj.currentTime = 0;
        if (videoObj) {
          this.totalT = videoObj.duration;
          this.videoTotalTime = this.formatSeconds(this.totalT * 1000);
        }
      };
    } else {
      if (videoObj) {
        this.totalT = videoObj.duration;
        this.videoTotalTime = this.formatSeconds(this.totalT * 1000);
      }
    }
  }
  videoProgress() {
    const audioElement = this.$refs[this.audioRef] as HTMLAudioElement;
    if (audioElement) {
      const bf = audioElement.buffered;
      const time = audioElement.currentTime;
      if (bf.length != 0) {
        let range = 0;
        while (!(bf.start(range) <= time && time <= bf.end(range))) {
          range += 1;
        }

        const loadEndPercentage = (bf.end(range) / audioElement.duration) * 100; // 结束加载的百分比
        this.persentLoad = loadEndPercentage;
      }
    }
  }

  @Emit()
  playAudio() {
    // const audioElement = this.$refs[this.audioRef] as HTMLAudioElement;
    const audioElement = document.getElementById(
      this.audioId
    ) as HTMLAudioElement;
    const audioElCopy = document.querySelector("audio#this.audioId");
    if (audioElement) {
      audioElement.play();
      audioElement.pause();
    }
    if (!this.isPlay) {
      this.playAudioDesc();
      audioElement.play();
    } else {
      audioElement.pause();
    }
    this.isPlay = !this.isPlay;
  }
  //asr时间格式化
  formatSeconds(mss: number) {
    const hours =
      Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10
        ? "0" + Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        : Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    const minutes =
      Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60)) < 10
        ? "0" + Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60))
        : Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));

    const seconds =
      (mss % (1000 * 60)) / 1000 < 10
        ? "0" + Math.floor((mss % (1000 * 60)) / 1000)
        : Math.floor((mss % (1000 * 60)) / 1000);
    return `${hours}:${minutes}:${seconds}`;
  }
  timeupdate({ target }: Event, answer: Answer) {
    // const player: HTMLMediaElement = e.target;
    try {
      this.presentT = (target as HTMLAudioElement).currentTime; // 获取当前播放时长
      this.videoCurrentTime = this.formatSeconds(this.presentT * 1000);
      answer.asrList.forEach((el, index: number) => {
        if (el.ed > (target as HTMLMediaElement).currentTime * 1000) {
          this.activeIndex = index;
          throw new Error("I");
        }
      });
    } catch (error) {
      error;
    }
  }
  playAudioDesc() {
    // 先停止其他音频
    const audioElements = document.querySelectorAll(".mp3-anchor");
    audioElements.forEach((audioElement: any) => {
      audioElement.pause();
    });
  }
}
